var recaptchaLoaded = false;

var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);

var cookie_source       = getCookie('sk_source'),
    cookie_campagna     = getCookie('sk_campagna'),
    cookie_gruppo       = getCookie('sk_gruppo'),
    cookie_annuncio     = getCookie('sk_annuncio'),
    cookie_keyword      = getCookie('sk_keyword'),
    cookie_utm_source   = getCookie('sk_utm_source'),
    cookie_utm_campaign = getCookie('sk_utm_campaign'),
    cookie_gclid        = getCookie('sk_gclid'),
    cookie_gid          = getCookie('_gid');

var timestampInMilliseconds = Date.now();
var expirationMilliseconds = 31556952;
var futureTimestamp = timestampInMilliseconds + expirationMilliseconds;

if (!cookie_source) {
    cookie_source = urlParams.get('source');
    if (!cookie_source) {
        cookie_source = 'direct';
    }
    setCookie('sk_source', cookie_source, futureTimestamp);
}
if (!cookie_campagna && urlParams.get('campagna')) {
    cookie_campagna = urlParams.get('campagna');
    setCookie('sk_campagna', cookie_campagna, futureTimestamp);
}
if (!cookie_gruppo && urlParams.get('gruppo')) {
    cookie_gruppo = urlParams.get('gruppo');
    setCookie('sk_gruppo', cookie_gruppo, futureTimestamp);
}
if (!cookie_annuncio && urlParams.get('annuncio')) {
    cookie_annuncio = urlParams.get('annuncio');
    setCookie('sk_annuncio', cookie_annuncio, futureTimestamp);
}
if (!cookie_keyword && urlParams.get('keyword')) {
    cookie_keyword = urlParams.get('keyword');
    setCookie('sk_keyword', cookie_keyword, futureTimestamp);
}
if (!cookie_utm_source) {
    cookie_utm_source = urlParams.get('utm_source');
    if (!cookie_utm_source) {
        cookie_utm_source = 'direct';
    }
    setCookie('sk_utm_source', cookie_utm_source, futureTimestamp);
}
if (!cookie_utm_campaign && urlParams.get('utm_campaign')) {
    cookie_utm_campaign = urlParams.get('utm_campaign');
    setCookie('sk_utm_campaign', cookie_utm_campaign, futureTimestamp);
}
if (!cookie_gclid && urlParams.get('gclid')) {
    cookie_gclid = urlParams.get('gclid');
    setCookie('sk_gclid', cookie_gclid, futureTimestamp);
}

var date = new Date();

// jQuery('.js-form-page-send').each(function (k, v) {
//     jQuery(v).val((location.protocol + '//' + location.host + location.pathname));
// });
// jQuery('.js-form-date-send').each(function (k, v) {
//     jQuery(v).val(new Date().toJSON().slice(0, 10));
// });
document.querySelectorAll('.js-form-utm-source').forEach(function (v, k) {
    if (cookie_utm_source) {
        v.value = cookie_utm_source;
    }
});
document.querySelectorAll('.js-form-utm-campaign').forEach(function (v, k) {
    if (cookie_utm_campaign) {
        v.value = cookie_utm_campaign;
    }
});

var sha256Loaded = false;
function loadSha256() {
    var head = document.querySelector('head'), script = document.createElement('script'), r = false;
    script.charset = 'utf-8';
    script.src = "/assets/js/vendor/js-sha256@0.11.0/sha256.min.js";
    head.appendChild(script);
}

document.querySelectorAll('.js-load-sha256').forEach(function (v, k) {
    v.addEventListener('click', function () {
        if (!sha256Loaded) {
            sha256Loaded = true;
            loadSha256();
        }
    })
});